(() => {
  const Airtable = require('airtable');
  const base = new Airtable({ apiKey: 'key3HtjBuyKdXX34l' }).base('appONUCM2JmSriz6M');

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const utils = {
    blurList: ($ul) => {
      let selected = $ul.querySelector("li.selected");
      selected.style.opacity = 1;
      let pp = selected, ppc = 0, np = selected, npc = 0;
      while (pp.previousElementSibling) {
        pp = pp.previousElementSibling;
        pp.style.opacity = 1 - (++ppc) / 8;
      }

      while (np.nextElementSibling) {
        np = np.nextElementSibling;
        np.style.opacity = 1 - (++ppc / 8);
      }
    },

    getParam: (key) => {
      const url = new URL(location.href);
    }
  };

  function hexToBase64(str) {
    return btoa(String.fromCharCode.apply(null,
      str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" "))
    );
  }

  function base64ToHex(str) {
    for (var i = 0, bin = atob(str.replace(/[ \r\n]+$/, "")), hex = []; i < bin.length; ++i) {
      var tmp = bin.charCodeAt(i).toString(16);
      if (tmp.length === 1) tmp = "0" + tmp;
      hex[hex.length] = tmp;
    }
    return hex.join(" ");
  }

  let w = (function x () { return this })();
  let e = (i) => {
    let b = w[Object.keys(w).find(o => /a.{2}b/.test(o))];
    return b(hexToBase64(i));
  };

  let RSVP_LIST = `41 64 61 6d 20 57 69 65 63 7a 6e 65 72 2c 61 64 61 6d 73 78 73 77 38 40 67 6d 61 69 6c 2e 63 6f 6d 2c 43 69 6e 64 79 20 42 6c 61 73 73 2c 63 6c 62 6c 61 73 73 40 67 6d 61 69 6c 2e 63 6f 6d 0a 41 6c 65 78 20 41 72 65 6e 61 2c 69 6d 40 61 6c 65 78 61 72 65 6e 61 2e 63 6f 6d 2c 2c 0a 41 6c 65 78 20 48 6f 6f 70 61 69 2c 61 6c 65 78 2e 68 6f 6f 70 61 69 40 67 6d 61 69 6c 2e 63 6f 6d 2c 41 6e 6e 61 20 42 61 72 6e 77 65 6c 6c 2c 61 6e 6e 61 2e 73 2e 62 61 72 6e 77 65 6c 6c 40 67 6d 61 69 6c 2e 63 6f 6d 0a 41 6c 65 78 20 4d 61 63 63 61 77 2c 61 6c 65 78 40 61 6c 65 78 6d 61 63 63 61 77 2e 63 6f 6d 2c 2c 0a 41 6c 69 20 4d 6f 72 61 2c 61 6c 69 6d 6f 72 61 30 38 40 67 6d 61 69 6c 2e 63 6f 6d 2c 43 61 72 72 69 6e 67 74 6f 6e 20 4c 6f 72 65 6e 7a 2c 0a 41 6c 6c 79 20 42 61 72 62 6f 75 72 2c 77 68 69 74 74 61 6c 6c 79 40 79 61 68 6f 6f 2e 63 6f 6d 2c 4a 65 72 65 6d 79 20 42 61 72 62 6f 75 72 2c 0a 41 6d 62 65 72 20 43 68 65 6c 6c 69 73 2c 43 68 65 6c 6c 69 73 61 6d 62 65 72 40 67 6d 61 69 6c 2e 63 6f 6d 2c 44 61 6e 6e 79 20 57 72 69 67 68 74 2c 0a 42 6c 61 6b 65 20 42 72 69 64 67 65 73 2c 62 6c 61 6b 65 62 72 69 64 67 65 73 30 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 42 72 69 61 6e 20 4b 72 61 75 73 7a 2c 62 72 69 61 6e 6b 72 61 75 73 7a 40 67 6d 61 69 6c 2e 63 6f 6d 2c 52 61 63 68 65 6c 20 43 68 61 72 61 74 61 6e 2c 72 61 63 68 61 72 61 74 61 6e 40 67 6d 61 69 6c 2e 63 6f 6d 0a 42 72 6f 6f 6b 65 20 42 75 63 6b 6c 61 6e 64 2c 62 6e 62 75 63 6b 6c 61 6e 64 33 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 42 72 79 61 6e 20 41 6d 72 69 74 74 2c 62 72 79 61 6e 2e 61 6d 72 69 74 74 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 43 61 72 6f 6c 65 20 57 65 6c 74 65 2c 63 61 6e 64 6a 65 6d 31 33 30 38 40 67 6d 61 69 6c 2e 63 6f 6d 2c 4a 69 6d 20 57 65 6c 74 65 2c 0a 43 68 61 72 69 73 20 41 62 65 6a 75 65 6c 61 2c 68 61 6e 6e 61 68 2e 63 2e 61 62 65 6a 75 65 6c 61 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 43 68 61 73 65 20 47 61 6c 61 76 69 7a 2c 63 68 61 73 65 2e 67 61 6c 61 76 69 7a 40 67 6d 61 69 6c 2e 63 6f 6d 2c 45 72 69 6e 6e 65 20 47 72 61 6e 74 2c 65 72 69 6e 6e 65 2e 67 72 61 6e 74 40 67 6d 61 69 6c 2e 63 6f 6d 0a 43 68 72 69 73 20 57 68 69 74 74 61 6b 65 72 2c 77 68 69 74 74 76 6d 69 40 79 61 68 6f 6f 2e 63 6f 6d 2c 2c 0a 43 68 72 69 73 74 6f 70 68 65 72 20 4c 65 65 2c 63 68 72 69 73 2e 6b 65 6c 76 69 6e 2e 6c 65 65 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 43 6f 72 65 79 20 57 68 69 74 74 61 6b 65 72 2c 63 6f 72 65 79 77 68 69 74 74 40 67 6d 61 69 6c 2e 63 6f 6d 2c 4c 69 73 61 20 57 68 69 74 74 61 6b 65 72 2c 0a 44 65 62 62 69 65 20 57 68 69 74 65 68 65 61 64 2c 74 68 6f 72 70 65 77 68 69 74 65 68 65 61 64 40 68 6f 74 6d 61 69 6c 2e 63 6f 6d 2c 54 68 6f 72 70 65 20 57 68 69 74 65 68 65 61 64 2c 0a 45 6d 6d 79 20 57 68 69 74 65 68 65 61 64 2c 73 6f 63 61 72 6c 6f 76 61 72 40 67 6d 61 69 6c 2e 63 6f 6d 2c 53 61 76 61 6e 6e 61 68 20 57 68 69 74 65 68 65 61 64 2c 0a 45 72 69 6b 61 20 41 72 6d 65 6e 74 61 2c 61 72 6d 65 6e 74 61 61 39 36 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 4a 61 63 6f 62 20 48 65 6c 62 65 72 67 2c 4a 61 6b 65 68 65 6c 62 65 72 67 40 67 6d 61 69 6c 2e 63 6f 6d 2c 4b 65 69 74 68 20 52 61 62 6f 69 73 2c 6b 72 61 62 6f 69 73 40 67 6d 61 69 6c 2e 63 6f 6d 0a 4a 44 20 52 6f 73 73 2c 6a 75 73 74 69 6e 64 79 6c 61 6e 72 6f 73 73 40 67 6d 61 69 6c 2e 63 6f 6d 2c 53 61 72 61 68 20 42 65 6e 67 61 72 64 2c 53 65 62 65 6e 67 61 72 64 40 67 6d 61 69 6c 2e 63 6f 6d 0a 4a 65 73 73 69 20 53 63 68 6e 65 69 64 65 72 2c 6a 73 63 68 6e 65 69 34 40 67 6d 61 69 6c 2e 63 6f 6d 2c 44 65 72 65 6b 20 53 61 6e 64 65 72 73 2c 0a 4a 6f 73 68 20 42 75 63 6b 6c 65 79 2c 62 75 63 6b 6c 65 79 6a 6f 73 68 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 4b 61 74 68 79 20 57 65 6c 74 65 2c 77 68 69 74 74 6b 63 6d 75 40 79 61 68 6f 6f 2e 63 6f 6d 2c 53 63 6f 74 74 20 4f 6c 73 6f 6e 2c 0a 4b 61 79 20 57 65 6c 74 65 2c 6b 6d 77 65 6c 74 65 40 67 6d 61 69 6c 2e 63 6f 6d 2c 53 61 67 65 20 57 65 6c 74 65 2c 73 61 67 65 2e 77 65 6c 74 65 40 79 6d 61 69 6c 2e 63 6f 6d 0a 4b 65 76 69 6e 20 54 6f 77 6e 65 2c 4b 65 76 74 6f 77 6e 65 35 31 40 67 6d 61 69 6c 2e 63 6f 6d 2c 41 6d 61 6e 64 61 20 44 61 76 69 73 2c 0a 4b 65 76 69 6e 20 56 61 72 6b 65 79 2c 6b 76 6e 76 61 72 6b 65 79 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 4c 61 63 68 79 20 47 72 6f 6f 6d 2c 6c 61 63 68 79 67 72 6f 6f 6d 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 4c 69 6e 68 20 4e 67 75 79 65 6e 2c 4c 69 6e 68 73 6f 63 63 65 72 31 30 40 68 6f 74 6d 61 69 6c 2e 63 6f 6d 2c 53 61 72 61 68 20 44 65 73 61 75 74 65 6c 73 2c 0a 4d 61 6c 69 6b 61 20 43 61 6e 74 6f 72 2c 6d 61 6c 69 6b 61 2e 63 61 6e 74 6f 72 40 67 6d 61 69 6c 2e 63 6f 6d 2c 5a 61 63 68 20 47 6f 72 6d 61 6e 2c 7a 61 63 68 61 72 79 72 67 6f 72 6d 61 6e 40 67 6d 61 69 6c 2e 63 6f 6d 0a 4d 61 72 67 61 72 65 74 20 48 69 67 67 69 6e 73 2c 4d 68 69 67 31 31 31 30 40 62 72 69 64 67 65 70 6f 69 6e 74 31 2e 63 6f 6d 2c 4d 69 63 68 61 65 6c 20 48 69 67 67 69 6e 73 2c 0a 4d 61 72 6b 20 57 65 6c 74 65 2c 6d 77 65 6c 74 65 40 73 61 6c 65 73 66 6f 72 63 65 2e 63 6f 6d 2c 2c 0a 4d 65 72 76 79 6e 20 53 74 65 61 64 6d 61 6e 2c 6d 65 72 76 79 6e 40 66 6c 65 78 70 6f 72 74 2e 63 6f 6d 2c 2c 0a 4d 69 63 68 61 65 6c 20 4b 65 6c 6c 65 72 2c 62 6d 6b 65 6c 6c 65 72 40 67 6d 61 69 6c 2e 63 6f 6d 2c 4d 69 63 68 61 65 6c 20 42 65 6c 6b 69 6e 2c 4d 65 40 6d 69 63 68 61 65 6c 62 65 6c 6b 69 6e 2e 63 6f 6d 0a 4d 69 63 68 61 65 6c 20 53 63 68 61 64 65 2c 6d 40 6d 73 63 68 61 64 65 2e 6d 65 2c 2a 2c 0a 4d 69 6b 65 20 57 61 77 73 7a 63 7a 61 6b 2c 6d 69 6b 65 77 61 77 73 7a 63 7a 61 6b 40 67 6d 61 69 6c 2e 63 6f 6d 2c 4d 65 6c 69 73 73 61 20 44 69 65 74 65 72 6c 65 2c 6d 65 6c 69 73 73 61 2e 64 69 65 74 65 72 6c 65 40 67 6d 61 69 6c 2e 63 6f 6d 0a 4e 61 74 61 6c 69 65 20 4c 6f 63 6b 77 6f 6f 64 2c 4e 5f 6c 6f 63 6b 77 6f 6f 64 36 40 79 61 68 6f 6f 2e 63 6f 6d 2c 2c 0a 4e 65 69 6c 20 57 68 69 74 65 68 65 61 64 2c 6e 65 69 6c 2e 72 2e 77 68 69 74 65 68 65 61 64 40 67 6d 61 69 6c 2e 63 6f 6d 2c 54 72 65 6e 74 6f 6e 20 52 69 67 67 73 2c 74 72 65 6e 74 6f 6e 2e 72 69 67 67 73 40 67 6d 61 69 6c 2e 63 6f 6d 0a 52 69 63 68 61 72 64 20 54 68 61 69 2c 72 69 63 68 61 72 64 70 74 68 61 69 40 67 6d 61 69 6c 2e 63 6f 6d 2c 49 73 68 61 20 50 61 64 68 79 65 2c 69 73 68 61 61 70 61 64 68 79 65 40 67 6d 61 69 6c 2e 63 6f 6d 0a 53 61 6d 20 4d 6f 72 72 69 73 6f 6e 2c 73 61 6d 40 73 61 6d 2e 76 67 2c 2c 0a 53 61 6d 61 6e 74 68 61 20 43 68 65 6c 6c 69 73 2c 53 61 6d 61 6e 74 68 61 2e 63 68 65 6c 6c 69 73 34 33 32 33 40 67 6d 61 69 6c 2e 63 6f 6d 2c 4e 69 6b 20 44 65 6c 70 68 69 61 2c 0a 53 68 69 72 69 79 61 20 54 68 61 6b 72 61 72 2c 73 74 68 61 6b 72 61 72 40 70 68 61 72 6d 61 63 79 2e 61 72 69 7a 6f 6e 61 2e 65 64 75 2c 2c 0a 53 74 65 6c 6c 61 20 55 6e 72 75 68 2c 6c 73 75 6e 72 75 68 40 67 6d 61 69 6c 2e 63 6f 6d 2c 2c 0a 54 65 72 72 79 20 43 68 65 6c 6c 69 73 2c 74 65 72 72 79 63 68 65 6c 6c 69 73 40 79 61 68 6f 6f 2e 63 6f 6d 2c 53 74 61 63 79 20 4c 61 70 6f 69 6e 74 65 2c 0a 54 72 61 63 65 79 20 43 68 65 6c 6c 69 73 2c 54 63 68 65 6c 6c 69 73 31 35 30 40 63 6f 6d 63 61 73 74 2e 6e 65 74 2c 4b 65 76 69 6e 20 54 6f 77 6e 65 2c 0a 56 69 6a 61 79 20 50 61 64 6d 61 6e 61 62 68 61 6e 2c 76 6d 70 40 67 6f 6f 67 6c 65 2e 63 6f 6d 2c 2c 0a 43 61 6d 69 65 20 47 6f 66 66 69 2c 63 67 6f 66 66 69 32 40 79 61 68 6f 6f 2e 63 6f 6d 2c 2c`;

  const numLeaves = document.querySelectorAll(".leaf").length
  const leafStyles = new Array(numLeaves).fill(0).map((o, i) => ({
    top: (150 / numLeaves) * i + Math.random() * 20 - 10 - 50,
    left: [0, 50, 100][i % 3] + Math.random() * 30 - 15,
    transform: ``,
  }));

  const urlRouter = () => {
    if (/rsvp/.test(location.href)) {
      document.querySelector(`li[data-name="rsvp"]`).click();
    } else {
      document.querySelector(`li[data-name="home"]`).click();
    }
  }
  const loadPage = () => {
    urlRouter();
  }

  leafStyles.unshift(null);
  leafStyles.forEach(o => {
    if (o) {
      o.leftDrift = (Math.random() * 10) - 5;
      o.leftDriftAcc = 0;
      o.rotateDrift = Math.random() * 8 - 4;
      o.rotateDriftAcc = 0;
    }
  });

  const hideForm = () => {
    document.querySelector(".rsvp-form-wrapper").classList.add("hide");
    document.querySelector(".RSVP-form").style.height = `450px`;
    document.querySelector(".RSVP-form").style.overflow = `hidden`;
    setTimeout(function () {
      document.querySelector(".rsvp-success").classList.remove("hide");
      document.querySelectorAll(".part--rsvp form").forEach(o => o.style.display = "none");
    }, 500);
  }

  const initializeRSVPs = (rsvps = null) => {
    const $RSVP = document.querySelector(".RSVP-form");

    for (let x = 0; x < rsvps.length - 1; x++) {
      const $clone = $RSVP.cloneNode(true);
      $clone.querySelectorAll("[name]");
      $clone.querySelector(".mailing-address").parentNode.removeChild($clone.querySelector(".mailing-address"))
      $RSVP.parentNode.insertBefore($clone, $RSVP.nextElementSibling);
    }

    document.querySelectorAll(".RSVP-form").forEach(($o, i) => {
      $o.querySelector("input[type='text']").value = rsvps[i];
    })

    document.querySelector(".rsvp-form-wrapper button").addEventListener("click", () => {
      const data = [...document.querySelectorAll(".part--rsvp form")].map($o => {
        const row = {};
        $o.querySelectorAll(`input[type="text"]`).forEach($v => {
          row[$v.name] = $v.value;
        });

        ["rsvp_optional_preference", "rsvp_sailing", "rsvp_wedding"].map(o => {
          let $val = $o.querySelector(`input[type="radio"][name="${o}"]:checked`)
          if (!$val) {
            console.log(o, $val)
            document.querySelector("#error").innerText = `* Please fill out all of the RSVP options.`;
            document.querySelector("#error").classList.add("show");
            throw "Error.";
          }

          let { value } = $val;
          console.log(value, o)
          if (value === "true") value = true;
          if (value === "false") value = false;
          row[$val.name] = value;
        })

        return row;
      });
      base('Wedding Invites').create(data.map(o => ({ fields: o })), function(err, records) {
        if (err) {
          console.error(err);
          return;
        }
        hideForm();

        localStorage.setItem("rsvp_filled", true)
      });
    });
  }

  const animateParts = (oldIndex, newIndex) => {
    const $oldPart = document.querySelector(`.part[data-part="${oldIndex + 1}"]`);
    const $newPart = document.querySelector(`.part[data-part="${newIndex + 1}"]`);
    if (!$newPart) return;
    const direction = oldIndex < newIndex ? `up` : `down`;
    $oldPart.classList.add(`fade-out--${direction}`);
    setTimeout(function () {
      $oldPart.classList.remove(`fade-out--${direction}`);
      $oldPart.classList.remove("show")
      $newPart.classList.add(`fade-in--${direction}`);
      $newPart.classList.add("show");
      setTimeout(function () {
        $newPart.classList.remove(`fade-in--${direction}`);
      }, 200);
    }, window.innerWidth > 800 ? 500 : 200);
  }

  const trollConsole = () => {
    const element = new Image();
    Object.defineProperty(element, 'id', {
      get: function () {
        /* Call callback function here */
        console.log('stop heckin around my site')
        if (localStorage.getItem("debug")) return;
        return;
        while (true) {
          continue;
        }
      }
    });
    console.log('%c', element);
  }

  const trollMutationObserver = () => {
    // Options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
      if (mutationsList[0].removedNodes.length === 0) return;
      let possibleNode = mutationsList[0].removedNodes[0];
      if (!possibleNode) return;
      if (possibleNode.matches(".rsvp-finder")) {
        document.body.insertBefore(possibleNode, document.body.firstChild);
        return;
      }

      if (mutationsList[0].previousSibling.parentNode.matches(".rsvp-finder")) {
        document.querySelector(".rsvp-finder").insertBefore(possibleNode, mutationsList[0].nextSibling)
        return;
      }

      if (mutationsList[0].previousSibling.parentNode.closest(".rsvp-finder")) {
        mutationsList[0].previousSibling.parentNode.insertBefore(possibleNode, mutationsList[0].nextSibling)
        return;
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(document.body, config);
  };

  const normalize = (email) => {
    const [start, end] = email.toLowerCase().trim().split("@");
    return start.replace(/\./g, "") + "@" + end;
  };

  const findRSVP = (() => {
    const emailMap = {}, people = [];
    e(RSVP_LIST).split(/\n/g).map(o => {
      const cells = o.split(/,/);

      cells[1] = normalize(cells[1])
      if (cells[3]) {
        cells[3] = normalize(cells[3])
      }

      const person1 = { name: cells[0].trim(), email: cells[1] };
      const person2 = (cells[2] && cells[2].length > 0) ? { name: (cells[2] === "*" ? "Guest name" : cells[2]).trim(), email: cells[3] === "*" ? null : cells[3] } : null;

      people.push(person1);
      if (person2) people.push(person2);

      emailMap[person1.email] = [person1, person2].filter(o => o);
      if (person2?.email) emailMap[person2.email] = [person1, person2].filter(o => o);
    })

    return (email) => emailMap[normalize(email)]
  })();

  const initializeRSVPFinder = () => {
    const $form = document.querySelector(".RSVP-finder-form");

    const processForm = (e) => {
      e.preventDefault();
      const email = normalize($form.querySelector("[name='email']").value)
      const reservation = findRSVP(email);

      const $error = document.querySelector("#rsvp-finder-error");
      console.log(reservation)
      if (!reservation) {
        $error.innerText = "Hmm. We couldn't find a reservation, try the email we sent your invite to.";
        $error.classList.add("show");
        return;
      } else {
        $error.classList.remove("show");
        localStorage.setItem("rsvp_email", email);
      }

      initializeRSVPs(reservation.map(o => o.name))
      $form.parentNode.classList.remove("show");
    }
    document.querySelector(".rsvp-finder button").addEventListener("click", processForm)
  }

  (() => {
    document.querySelectorAll("li").forEach(node => node.addEventListener("click", function () {
      document.querySelector("#app").classList.add("show-content");
      if (this.classList.contains("selected")) return;

      const $ul = this.closest("ul");
      const $prev = $ul.querySelector(".selected");
      const $children = [...$prev.parentElement.children];
      const oldIndex = $children.indexOf($prev);
      $prev.classList.remove("selected");
      const newIndex = $children.indexOf(this);
      this.classList.add("selected");
      utils.blurList($ul);
      animateParts(oldIndex, newIndex)

      oneTimeAdjustment = (newIndex - oldIndex) * 8;
      leafLoop(false);
    }))

    utils.blurList(document.querySelector("ul"))

    let hasRun = false,
        oneTimeAdjustment = 0;
    const leafLoop = (repeat = true) => {
      if (document.hidden) {
        if (repeat) setTimeout(() => leafLoop(repeat), 1000);
        return;
      }
      if (oneTimeAdjustment && repeat) return;

      let count = 0;
      document.querySelectorAll(".leaf").forEach($leaf => {
        ++count;
        if (oneTimeAdjustment) {
          $leaf.style.transition = "all 1s ease";
          setTimeout(function () {
            $leaf.style.removeProperty("transition");
          }, 1000);
        }
        const styles = leafStyles[count]
        if (!isMobile) styles.top += 2 + oneTimeAdjustment;
        if (styles.top > 140) {
          $leaf.classList.add("no-animate");
          styles.top -= 170;
          styles.leftDriftAcc = 0;
          styles.rotateDriftAcc = 0;
          setTimeout(() => $leaf.classList.remove("no-animate"), 100)
        }
        for (let x in styles) {
          if (x === "left") {
            styles.leftDriftAcc += styles.leftDrift;
            styles.rotateDriftAcc += styles.rotateDrift;
            if (styles.left > 100) styles.left = 100;
            if (styles.left < -100) styles.left = -100;
            $leaf.style.left = styles.left + "%";
            if (styles.leftDriftAcc > 100) styles.leftDriftAcc = 100;
            $leaf.style.transform = styles.transform + `rotate(${180 - styles.rotateDriftAcc}deg) translateX(${styles.leftDriftAcc}%)`;
          } else if (x === "top") {
            $leaf.style[x] = styles[x] + "%";
          } else if (x === "transform") {
            // do nothing..
          } else {
            $leaf.style[x] = styles[x];
          }
        }
        if (!hasRun) $leaf.classList.remove("no-animate");
      })

      if (repeat) setTimeout(() => leafLoop(repeat), 1000);
      oneTimeAdjustment = 0;
      if (!hasRun) {
        hasRun = true;
      }
    }
    leafLoop();
    setTimeout(function () {
      document.querySelector("#app").classList.remove("hide");
    }, 750);

    const attemptGoToNextPage = () => {
      document.querySelector("li.selected:not(.hide)").nextElementSibling?.click();
      if (document.querySelector("li.selected:not(.hide)").nextElementSibling) {
        document.querySelector("#down").classList.add("show");
      } else {
        document.querySelector("#down").classList.remove("show");
      }
    };

    const attemptGoToPrevPage = () => {
      document.querySelector("li.selected:not(.hide)").previousElementSibling?.click();
      document.querySelector("#down").classList.add("show");
    };

    let lastMoved = new Date(), lastIntraMoved = new Date();

    const onScroll = function (e) {
      const $shownPart = document.querySelector('.part.show');
      const atBottom = ($shownPart.scrollHeight - $shownPart.getBoundingClientRect().height) - $shownPart.scrollTop < 1;
      const atTop = $shownPart.scrollTop === 0;

      if ((atBottom && e.deltaY > 0) || (atTop && e.deltaY < 0)) {
        if (new Date() - lastIntraMoved < 500) return;

        if (e.deltaY > 20 && new Date() - lastMoved > 500) {
          lastMoved = new Date();
          attemptGoToNextPage()
        } else if (e.deltaY < -20 && new Date() - lastMoved > 500) {
          lastMoved = new Date();
          attemptGoToPrevPage();
        }
        e.preventDefault();
      } else {
        lastIntraMoved = new Date();
      }
    };
    window.addEventListener("mousewheel", onScroll);
    window.addEventListener("scroll", onScroll);

    document.querySelector(".back-button").addEventListener("click", () => {
      document.querySelector("#app").classList.remove("show-content");
    });

    document.querySelector("#down").addEventListener("click", attemptGoToNextPage)

    const potentialEmail = localStorage.getItem("rsvp_email");
    const rsvpFilled = localStorage.getItem("rsvp_filled");

    if (potentialEmail) {
      initializeRSVPs(findRSVP(potentialEmail).map(o => o.name));
      document.querySelector(".rsvp-finder").classList.remove("show");
      document.querySelector(".rsvp-form-wrapper").classList.add("no-animate");
      setTimeout(function () {
        document.querySelector(".rsvp-form-wrapper").classList.remove("no-animate");
      }, 1000);
    }

    if (rsvpFilled) {
      hideForm()
    } else {
      if (!isMobile) document.querySelector(".RSVP-finder-form input").focus()
    }

    initializeRSVPFinder();
    loadPage();

    const appHeight = () => {
      if (isMobile) {
        const doc = document.documentElement;
        const height = Math.min(document.body.clientHeight, window.innerHeight);
        doc.style.setProperty('--app-height', `${height}px`)
      }
    }
    console.log(document.body.clientHeight, window.innerHeight);
    window.addEventListener('resize', appHeight);
    window.add
    appHeight()
    trollConsole();
    trollMutationObserver();
  })();

  /*
  How should the page animation work?
  I think they should be simple, but what comes to four distinct steps with two
  animation breaks.

  Step 1: OLD CONTENT IN PLAIN VIEW. (.show)
  Step 2: OLD CONTENT SLIDES UP. (.show.fade-out)
  Step 3: NEW CONTENT SLIDES UP. (.fade-in)
  Step 4: NEW CONTENT IN PLAIN VIEW. (.show)

  */
})();